import {
	Box,
	Checkbox,
	Button,
	Divider,
	FormControl,
	InputBase,
	InputLabel,
	ListItemText,
	ListSubheader,
	MenuItem,
	OutlinedInput,
	Select,
	Grid,
} from "@mui/material";
import {
	DateRangePicker,
	SingleInputDateRangeField,
} from "@mui/x-date-pickers-pro";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import "moment/locale/es";
import { useTranslation } from "react-i18next";
import { getBorder } from "utils/Styles";
import { useContext, useEffect, useState } from "react";
import { shortcuts } from "utils/Times";
import SearchIcon from "@mui/icons-material/Search";
import { gettingEmployees } from "utils/Filter";
//import { LoadingButton } from "@mui/lab"
import moment from "moment";
import { Context } from "./Context";

const Toolbar = () => {
	const { t } = useTranslation();

	const {
		tableDateRange,
		setTableDateRange,
		tags,
		tag,
		setTag,
		filterTags,
		setFilterTags,
		loadingGettingTags,
		employees,
		setEmployees,
		employee,
		setEmployee,
		filterEmployees,
		setFilterEmployees,
		loadingGettingEmployees,
		setLoadingGettingEmployees,
		reloading,
	} = useContext(Context);

	const [firtsRender, setFirstRender] = useState(true);

	useEffect(() => {
		if (firtsRender && employee.length !== 0) {
			reloading();

			setFirstRender(false);
		}
	}, [firtsRender, employee, reloading]);

	return (
		<>
			<Box
				width={{ sm: "80%", md: "90%", lg: "100%" }}
				sx={{
					flexDirection: "row",
					justifyContent: "flex-start",
					alignItems: "center",
					gap: 2,
					p: 1.5,
					borderBottom: (theme) => getBorder(theme.palette.mode),
				}}
			>
				<Grid container spacing={2} direction={"row"}>
					<Grid size={{ sm: 2, md: 3, lg: 3 }}>
						<LocalizationProvider
							dateAdapter={AdapterMoment}
							adapterLocale={moment.locale()}
						>
							<DateRangePicker
								label={t("utils.filter.range_of_days")}
								slots={{ field: SingleInputDateRangeField }}
								slotProps={{
									shortcuts: {
										items: shortcuts(t),
									},
									textField: {
										size: "large",
									},
								}}
								//format={JSON.parse(sessionStorage.getItem('config'))?.date_format}
								calendars={1}
								fullwith
								onChange={(value) => {
									setTableDateRange(value);
								}}
								value={tableDateRange}
								sx={{
									width: "100%",
								}}
							/>
						</LocalizationProvider>
					</Grid>

					<Grid size={{ sm: 3, md: 3, lg: 3 }}>
						<FormControl
							fullWidth
							required
							error={tag.length === 0 && !loadingGettingTags}
						>
							<InputLabel id="lsg">
								{t("utils.filter.tags")}
							</InputLabel>

							<Select
								labelId="lsg"
								id="sg"
								multiple
								value={tag.map((t) => t.name)}
								input={
									<OutlinedInput
										label={t("utils.filter.tags")}
									/>
								}
								renderValue={(selected) => selected.join(", ")}
								MenuProps={{
									style: {
										maxHeight: "400px",
									},
								}}
							>
								{tags?.length !== 0 && !loadingGettingTags && (
									<Box>
										<Checkbox
											sx={{ ml: 2 }}
											checked={
												filterTags === ""
													? tags.filter((t) =>
															tag
																.map(
																	(t) =>
																		t.name
																)
																.includes(
																	t.name
																)
													  ).length === tags.length
													: tags
															.filter((tg) =>
																tg.name
																	.toLowerCase()
																	.includes(
																		filterTags.toLocaleLowerCase()
																	)
															)
															.every((tg) =>
																tag
																	.map(
																		(t) =>
																			t.name
																	)
																	.includes(
																		tg.name
																	)
															)
											}
											indeterminate={
												filterTags === ""
													? tags.filter((t) =>
															tag
																.map(
																	(t) =>
																		t.name
																)
																.includes(
																	t.name
																)
													  ).length !==
															tags.length &&
													  tag.length > 0
													: !tags
															.filter((tg) =>
																tg.name
																	.toLowerCase()
																	.includes(
																		filterTags.toLocaleLowerCase()
																	)
															)
															.every((tg) =>
																tag
																	.map(
																		(t) =>
																			t.name
																	)
																	.includes(
																		tg.name
																	)
															) &&
													  !tags
															.filter((tg) =>
																tg.name
																	.toLowerCase()
																	.includes(
																		filterTags.toLocaleLowerCase()
																	)
															)
															.every(
																(tg) =>
																	!tag
																		.map(
																			(
																				t
																			) =>
																				t.name
																		)
																		.includes(
																			tg.name
																		)
															) &&
													  tags.filter((tg) =>
															tg.name
																.toLowerCase()
																.includes(
																	filterTags.toLocaleLowerCase()
																)
													  ).length !== 0
											}
											onChange={(e) => {
												if (e.target.checked) {
													setTag(
														tags
															.filter((tg) =>
																tg.name
																	.toLowerCase()
																	.includes(
																		filterTags.toLocaleLowerCase()
																	)
															)
															.map((tg) => tg)
													);
													gettingEmployees(
														setLoadingGettingEmployees,
														setEmployees,
														setEmployee,
														tags
															.filter((tg) =>
																tg.name
																	.toLowerCase()
																	.includes(
																		filterTags.toLocaleLowerCase()
																	)
															)
															.map((tg) => tg.id),
														{
															tags_id_in:
																JSON.stringify(
																	tags.map(
																		(tag) =>
																			tag.tag_id
																	)
																),
															start_date:
																tableDateRange[0].format(
																	"YYYY-MM-DD"
																),
															end_date:
																tableDateRange[1].format(
																	"YYYY-MM-DD"
																),
														}
													);
												} else {
													setTag(
														tags.filter(
															(t) =>
																!tags
																	.filter(
																		(tg) =>
																			tg.name
																				.toLowerCase()
																				.includes(
																					filterTags.toLocaleLowerCase()
																				)
																	)
																	.map(
																		(tg) =>
																			tg.name
																	)
																	.includes(
																		t.name
																	)
														)
													);
													gettingEmployees(
														setLoadingGettingEmployees,
														setEmployees,
														setEmployee,
														tags
															.filter(
																(t) =>
																	!tags
																		.filter(
																			(
																				tg
																			) =>
																				tg.name
																					.toLowerCase()
																					.includes(
																						filterTags.toLocaleLowerCase()
																					)
																		)
																		.map(
																			(
																				tg
																			) =>
																				tg.name
																		)
																		.includes(
																			t.name
																		)
															)
															.map((t) => t.id),
														{
															tags_id_in:
																JSON.stringify(
																	tags.map(
																		(tag) =>
																			tag.tag_id
																	)
																),
															start_date:
																tableDateRange[0].format(
																	"YYYY-MM-DD"
																),
															end_date:
																tableDateRange[1].format(
																	"YYYY-MM-DD"
																),
														}
													);
												}
											}}
										/>

										<InputBase
											sx={{
												width: "70%",
												mx: 1.5,
												my: 1.5,
											}}
											placeholder={t(
												"utils.filter.search"
											)}
											endAdornment={
												<SearchIcon sx={{ mr: 1 }} />
											}
											value={filterTags}
											onChange={(e) =>
												setFilterTags(e.target.value)
											}
										/>

										<Divider />

										{tags
											.filter((t) =>
												t.name
													.toLowerCase()
													.includes(
														filterTags.toLocaleLowerCase()
													)
											)
											.map((tg) => (
												<MenuItem
													key={tg.id}
													onClick={() => {
														if (
															tag.filter(
																(t) =>
																	t.name ===
																	tg.name
															).length > 0
														) {
															setTag(
																tag.filter(
																	(t) =>
																		t.name !==
																		tg.name
																)
															);
															gettingEmployees(
																setLoadingGettingEmployees,
																setEmployees,
																setEmployee,
																tag
																	.filter(
																		(t) =>
																			t.name !==
																			tg.name
																	)
																	.map(
																		(t) =>
																			t.id
																	),
																{
																	tags_id_in:
																		JSON.stringify(
																			tags.map(
																				(
																					tag
																				) =>
																					tag.tag_id
																			)
																		),
																	start_date:
																		tableDateRange[0].format(
																			"YYYY-MM-DD"
																		),
																	end_date:
																		tableDateRange[1].format(
																			"YYYY-MM-DD"
																		),
																}
															);
														} else {
															setTag([
																...tag,
																tg,
															]);
															gettingEmployees(
																setLoadingGettingEmployees,
																setEmployees,
																setEmployee,
																[
																	...tag,
																	tg,
																].map(
																	(t) => t.id
																),
																{
																	tags_id_in:
																		JSON.stringify(
																			tags.map(
																				(
																					tag
																				) =>
																					tag.tag_id
																			)
																		),
																	start_date:
																		tableDateRange[0].format(
																			"YYYY-MM-DD"
																		),
																	end_date:
																		tableDateRange[1].format(
																			"YYYY-MM-DD"
																		),
																}
															);
														}
													}}
												>
													<Checkbox
														checked={
															tag.filter(
																(t) =>
																	t.name ===
																	tg.name
															).length > 0
														}
													/>
													<ListItemText
														primary={tg.name}
													/>
												</MenuItem>
											))}
									</Box>
								)}
							</Select>
						</FormControl>
					</Grid>

					<Grid size={{ sm: 3, md: 4, lg: 4 }}>
						<FormControl
							fullWidth
							error={
								employee.length === 0 &&
								!loadingGettingEmployees
							}
						>
							<InputLabel id="lem">
								{t("utils.filter.employees")}
							</InputLabel>

							<Select
								labelId="lem"
								id="em"
								multiple
								value={employee.map((e) => e.full_name)}
								input={
									<OutlinedInput
										label={t("utils.filter.employees")}
									/>
								}
								renderValue={(selected) => selected.join(", ")}
								MenuProps={{
									style: {
										maxHeight: "400px",
									},
								}}
							>
								{employees.length !== 0 &&
									!loadingGettingEmployees && (
										<Box>
											<InputBase
												sx={{
													width: "calc(100% - 80px)",
													ml: 1,
													mb: 1.5,
												}}
												placeholder={t(
													"utils.filter.search"
												)}
												endAdornment={
													<SearchIcon
														sx={{ mr: 1 }}
													/>
												}
												value={filterEmployees}
												onChange={(e) =>
													setFilterEmployees(
														e.target.value
													)
												}
											/>

											<Divider />

											{tags
												.filter((tg) =>
													tag
														.map((tg) => tg.name)
														.includes(tg.name)
												)
												.map((tg) => (
													<Box key={tg.id}>
														<ListSubheader>
															{tg.name}
														</ListSubheader>

														{employees
															.filter(
																(e) =>
																	e.tag ===
																	tg.name
															)
															.filter((e) =>
																e.full_name
																	.toLowerCase()
																	.includes(
																		filterEmployees.toLocaleLowerCase()
																	)
															)
															.map((e) => (
																<MenuItem
																	key={`${e.id}-${e.tag}`}
																	value={
																		e.full_name
																	}
																	onClick={() => {
																		if (
																			employee.find(
																				(
																					emp
																				) =>
																					emp.full_name ===
																					e.full_name
																			)
																		) {
																			setEmployee(
																				[]
																			);
																		} else {
																			setEmployee(
																				[
																					e,
																				]
																			);
																		}
																	}}
																>
																	<ListItemText
																		primary={
																			e.full_name
																		}
																	/>
																</MenuItem>
															))}
													</Box>
												))}
										</Box>
									)}
							</Select>
						</FormControl>
					</Grid>

					<Grid size={{ sm: 2, md: 2, lg: 2 }}>
						<Button
							size="large"
							fullWidth
							sx={{ height: "100%" }}
							loading={loadingGettingEmployees}
							variant="contained"
							disabled={
								tableDateRange[0] === null ||
								tableDateRange[1] === null ||
								tag.length === 0 ||
								employee.length === 0
							}
							onClick={() => reloading()}
						>
							{t("utils.filter.search")}
						</Button>
					</Grid>
				</Grid>
			</Box>
		</>
	);
};

export { Toolbar };
